// src/store/modules/auth.js
import { apiClient, login as apiLogin, getProfile } from '@/api/auth'

export default {
  namespaced: true,
  state: () => ({
    token: localStorage.getItem('auth_token') || null,
    user: null,
    loading: false,
    error: null
  }),
  mutations: {
    SET_LOADING(state, val) {
      state.loading = val
    },
    SET_ERROR(state, err) {
      state.error = err
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER(state, user) {
      state.user = user
    }
  },
  actions: {
    async init({ commit, dispatch }) {
      const token = localStorage.getItem('auth_token')
      if (!token) return
      apiClient.defaults.headers.common.Authorization = `Bearer ${token}`
      commit('SET_TOKEN', token)
      try {
        // ✅ verify token & load user
        const { data } = await getProfile()
        commit('SET_USER', data.user)
      } catch (err) {
        // invalid / expired → clean up
        dispatch('logout')
        throw err  // <-- bubble up so init() rejects

      }
    },
    async login({ commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const { data } = await apiLogin(payload)
        const token = data.token
        localStorage.setItem('auth_token', token)
        apiClient.defaults.headers.common.Authorization = `Bearer ${token}`
        commit('SET_TOKEN', token)
        // grab user immediately
        const { data: profile } = await getProfile()
        commit('SET_USER', profile.user)
      } catch (err) {
        commit('SET_ERROR', err.response?.data?.message || err.message)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },
    logout({ commit }) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)
      delete apiClient.defaults.headers.common.Authorization
      localStorage.removeItem('auth_token')
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    authError:     (state) => state.error,
    isLoading:     (state) => state.loading,
    currentUser:   (state) => state.user
  }
}
